export class VehicleEmissionClassesInitialize {
  static readonly type = '[Vehicle Emission Classes] Initialize';
}

export class InitializeVehicleClassesState {
  static readonly type =
    '[Vehicle Emission Classes] InitializeVehicleClassesState';
}
